// PWA: registrace service workeru, sledování online/offline a instalační prompt.
let online = typeof navigator !== 'undefined' ? navigator.onLine : true;
const onlineListeners = new Set<(o: boolean) => void>();
const setOnline = (o: boolean) => { online = o; onlineListeners.forEach((l) => l(o)); };

export const onlineState = {
  get: () => online,
  subscribe: (fn: (o: boolean) => void) => { onlineListeners.add(fn); return () => { onlineListeners.delete(fn); }; },
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let deferredPrompt: any = null;
const installListeners = new Set<() => void>();
export const install = {
  available: () => !!deferredPrompt,
  subscribe: (fn: () => void) => { installListeners.add(fn); return () => { installListeners.delete(fn); }; },
  async prompt() {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    try { await deferredPrompt.userChoice; } catch { /* ignore */ }
    deferredPrompt = null;
    installListeners.forEach((l) => l());
  },
};

export function initPwa(onReconnect: () => void): void {
  window.addEventListener('online', () => { setOnline(true); onReconnect(); });
  window.addEventListener('offline', () => setOnline(false));
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    installListeners.forEach((l) => l());
  });
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => { navigator.serviceWorker.register('/sw.js').catch(() => {}); });
  }
}
